import React, { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { MobileBottomNav } from './MobileBottomNav';
import { RequestCallModal } from './modals/RequestCallModal';
export function DashboardLayout() {
  const [showRequestCallModal, setShowRequestCallModal] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const handleRequestCall = () => {
    setShowRequestCallModal(true);
  };
  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };
  const handleNavigate = (path: string) => {
    navigate(path);
    setIsMobileSidebarOpen(false);
  };
  // Determine current page for MobileBottomNav
  let currentPage: 'dashboard' | 'ai-copilot' | 'all-templates' = 'dashboard';
  if (location.pathname === '/all-templates') {
    currentPage = 'all-templates';
  } else if (location.pathname === '/ai-copilot') {
    currentPage = 'ai-copilot';
  }
  return <>
      <div className="flex h-screen bg-white overflow-hidden" data-id="element-489">
        {/* Sidebar - Hidden on mobile by default */}
        <div className="hidden lg:block" data-id="element-490">
          <Sidebar onNavigate={handleNavigate} currentPath={location.pathname} data-id="element-491" />
        </div>

        {/* Mobile Sidebar Overlay */}
        {isMobileSidebarOpen && <div className="lg:hidden fixed inset-0 z-40 flex" data-id="element-492">
            <div className="fixed inset-0 bg-black/50" onClick={() => setIsMobileSidebarOpen(false)} data-id="element-493" />
            <div className="relative z-50 w-64 h-full bg-white shadow-xl" data-id="element-494">
              <Sidebar onNavigate={handleNavigate} currentPath={location.pathname} data-id="element-495" />
            </div>
          </div>}

        <div className="flex-1 overflow-auto w-full pb-16 lg:pb-0" data-id="element-496">
          <Outlet context={{
          toggleMobileSidebar
        }} data-id="element-497" />
        </div>
      </div>

      <MobileBottomNav currentPage={currentPage} onNavigateToDashboard={() => handleNavigate('/dashboard')} onNavigateToAICopilot={() => handleNavigate('/ai-copilot')} onNavigateToDocuments={() => handleNavigate('/all-templates')} onRequestCall={handleRequestCall} data-id="element-498" />

      {showRequestCallModal && <RequestCallModal onClose={() => setShowRequestCallModal(false)} data-id="element-499" />}
    </>;
}